import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Auth from "../../utils/AuthUtils";
import userAPI from "../../api/UserApi";
import { getTimeAgo } from "../../helper/Helper";
import { ShoppingBag, ArrowRight } from "lucide-react";

const STATUS_MAP = {
  delivered:    { dot: "#2e7d32", color: "#2e7d32" },
  "in transit": { dot: "#e65100", color: "#e65100" },
  processing:   { dot: "#1565c0", color: "#1565c0" },
  cancelled:    { dot: "#c62828", color: "#c62828" },
  pending:      { dot: "#f57f17", color: "#f57f17" },
};

function Dashboard() {
  const { username } = Auth.getToken();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    fetchLatestOrder();
  }, []);

  const fetchLatestOrder = async () => {
    try {
      const res = await userAPI.fetchLatestOrder();
      if (res.code === 200) {
        setOrder(res.data);
      }
    } catch (err) {}
  };

  const statusKey  = order?.status?.toLowerCase();
  const statusMeta = STATUS_MAP[statusKey] || { dot: "#999", color: "var(--color-text-muted)" };

  return (
    <div>
      {/* ── HERO ── */}
      <div className="vp-dash-hero">
        <p className="vp-dash-eyebrow">Welcome back,</p>
        <h4 className="vp-dash-name">{username}</h4>
        <p className="vp-dash-desc">
          Today is a great day to check your account. You can view{" "}
          <NavLink to="/users/orders">your orders</NavLink> or explore{" "}
          <NavLink to="/shop">latest products</NavLink>.
        </p>
      </div>

      {/* ── LATEST ORDER ── */}
      <p className="vp-eyebrow">Recent Activity</p>
      <h2 className="vp-title">Latest Order</h2>
      <div className="vp-rule" />

      {order ? (
        <div className="vp-order">
          <div className="vp-order-info">
            <p className="vp-order-id">Order #{order.orderId}</p>
            <p className="vp-order-date">{getTimeAgo(order?.createdAt)}</p>
            <p className="vp-order-amount">₹{order?.total}/-</p>
            <span
              className="vp-order-status"
              style={{ color: statusMeta.color }}
            >
              <span
                className="vp-order-dot"
                style={{ background: statusMeta.dot }}
              />
              {order?.status}
            </span>
          </div>
          <div className="vp-order-right">
            <Link to="/users/orders" className="vp-btn-ghost">
              View All <ArrowRight size={11} />
            </Link>
          </div>
        </div>
      ) : (
        <div className="vp-empty">
          <ShoppingBag size={46} className="vp-empty-icon" />
          <p className="vp-empty-title">No orders yet</p>
          <p className="vp-empty-sub">It's time to make your first order.</p>
          <Link to="/shop" className="vp-btn-primary">
            Shop Now <ArrowRight size={13} />
          </Link>
        </div>
      )}
    </div>
  );
}

export default Dashboard;